var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-sidebar-layout",
    { attrs: { logo: "logo-profmos" } },
    [
      _c(
        "ui-menu",
        { attrs: { slot: "menu" }, slot: "menu" },
        [
          _c("ui-menu-group", { attrs: { title: "Overzicht" } }),
          _vm.$can("ROUTE_OVERVIEW_PERIOD")
            ? _c("ui-menu-item", {
                attrs: {
                  title: "Per periode",
                  icon: "magicon-calendar",
                  route: "overview-period",
                },
              })
            : _vm._e(),
          _vm.$can("ROUTE_COHORTS")
            ? _c("ui-menu-item", {
                attrs: {
                  title: "Huidige partijen",
                  icon: "magicon-inbox",
                  route: "current-cohorts",
                },
              })
            : _vm._e(),
          _vm.$can("ROUTE_COHORT_DETAIL")
            ? _c("ui-menu-item", {
                attrs: {
                  title: "Partij volgen",
                  icon: "magicon-jump-right-up",
                  route: "cohort-detail",
                },
              })
            : _vm._e(),
          _vm.$can("ROUTE_WATER_INSIGHTS")
            ? _c("ui-menu-item", {
                attrs: {
                  title: "Water inzichten",
                  icon: "entypo-water",
                  route: "water-insights",
                },
              })
            : _vm._e(),
          _c("ui-menu-group", { attrs: { title: "Beheer" } }),
          _vm.$can("ROUTE_GROWERS")
            ? _c("ui-menu-item", {
                attrs: {
                  title: "Mosselkwekers",
                  icon: "fa-building",
                  route: "growers",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$can("ROUTE_SHIPS")
            ? _c("ui-menu-item", {
                attrs: { title: "Schepen", icon: "fa-ship", route: "ships" },
              })
            : _vm._e(),
          _vm.$can("ROUTE_USERS")
            ? _c("ui-menu-item", {
                attrs: {
                  title: "Gebruikers",
                  icon: "fa-user-circle-o",
                  route: "users",
                },
              })
            : _vm._e(),
          _vm.$can("ROUTE_PARCELS")
            ? _c("ui-menu-item", {
                attrs: {
                  title: "Percelen",
                  icon: "magicon-resize-plus-3",
                  route: "parcels",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$can("ROUTE_SECTIONS")
            ? _c("ui-menu-item", {
                attrs: {
                  title: "Vakken",
                  icon: "magicon-tiles",
                  route: "sections",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "topbar-actions",
          attrs: { slot: "topbar-actions" },
          slot: "topbar-actions",
        },
        [
          _c(
            "router-link",
            { staticClass: "account", attrs: { to: { name: "account" } } },
            [
              _c("i", { staticClass: "magicon-user" }),
              _c("span", [_vm._v("Mijn account")]),
            ]
          ),
          _c("a", { staticClass: "help", attrs: { href: "#" } }, [
            _c("i", { staticClass: "entypo-help" }),
          ]),
          _c(
            "button",
            {
              staticClass: "logout",
              attrs: { type: "button", "aria-label": "Uitloggen" },
              on: { click: _vm.logout },
            },
            [_c("i", { staticClass: "entypo-log-out" })]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }